export default "__VITE_ASSET__Cc98LvqU__"